// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  restaurantId: __t.u64(),
  clientTempId: __t.string(),
  variant: __t.string(),
  archetype: __t.string(),
  tasteDiet: __t.string(),
  tasteDecorPref: __t.f32(),
  tasteWindowPref: __t.f32(),
  tasteCuisineBias: __t.string(),
  tasteDrinkTolerance: __t.f32(),
  willUseToilet: __t.bool(),
  doorX: __t.f32(),
  doorZ: __t.f32(),
  doorFloor: __t.u32(),
  patienceMultX100: __t.i32(),
  willWashOnly: __t.bool(),
};
